import React, { useState, useRef } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import video from "../assets/videos/video.mp4";

const videoChunks = [
  { end: 12, label: 'NUDITÉ', start: 7 },
  { end: 10, label: 'SCÈNE INTIME', start: 3 },
  { end: 67, label: 'VIOLENCE PHYSIQUE', start: 60 },
  { end: 30, label: 'VULGARITÉ SONORE', start: 3 },
  { end: 25, label: 'VULGARITÉ VISUELLE', start: 10 },
  { end: 130, label: 'VULGARITÉ SONORE', start: 120 },
  { end: 90, label: 'VULGARITÉ VISUELLE', start: 80 }
];

const chunkLabelToLowercase = (label) => {
  switch (label) {
    case "NUDITÉ": return "nudité";
    case "SCÈNE INTIME": return "scène intime";
    case "VIOLENCE PHYSIQUE": return "violence physique";
    case "VULGARITÉ SONORE": return "vulgarité sonore";
    case "VULGARITÉ VISUELLE": return "vulgarité visuelle";
    default: return label.toLowerCase();
  }
};

function findOverlappingEnd(chunks, currentTime) {
  let overlappingChunks = chunks.filter(chunk => 
    (chunk.label === "VULGARITÉ SONORE" || chunk.label === "VULGARITÉ VISUELLE") &&
    chunk.start <= currentTime && chunk.end > currentTime
  );
  
  if (overlappingChunks.length < 2) return null;
  
  let soundChunk = overlappingChunks.find(chunk => chunk.label === "VULGARITÉ SONORE");
  let visualChunk = overlappingChunks.find(chunk => chunk.label === "VULGARITÉ VISUELLE");
  
  if (!soundChunk || !visualChunk) return null;
  
  return Math.min(soundChunk.end, visualChunk.end);
}

function PermissionsTest() {
  const [filters, setFilters] = useState({
    "NUDITÉ": true,
    "SCÈNE INTIME": true,
    "VIOLENCE PHYSIQUE": true,
    "VULGARITÉ SONORE": true,
    "VULGARITÉ VISUELLE": true,
  });

  const [videoStyle, setVideoStyle] = useState({});
  const videoRef = useRef(null);
  const lastToastRef = useRef(null);

  const handleTimeUpdate = () => {
    const currentTime = videoRef.current.currentTime;
    
    const activeChunks = videoChunks.filter(
      chunk => currentTime >= chunk.start && currentTime < chunk.end && filters[chunk.label]
    );

    if (activeChunks.length === 0) {
      setVideoStyle({ filter: "none" });
      videoRef.current.muted = false;
      lastToastRef.current = null;
      return;
    }

    const overlappingEnd = findOverlappingEnd(videoChunks, currentTime);
    if (overlappingEnd) {
      videoRef.current.currentTime = overlappingEnd;
      setVideoStyle({ filter: "none" });
      videoRef.current.muted = false;
      toast.info("La scène a été sautée car elle contient de la vulgarité sonore et visuelle.");
      return;
    }

    const skipTypes = ["NUDITÉ", "SCÈNE INTIME", "VIOLENCE PHYSIQUE"];
    const needsSkip = activeChunks.some(chunk => skipTypes.includes(chunk.label));
    const hasSoundVulgarity = activeChunks.some(chunk => chunk.label === "VULGARITÉ SONORE");
    const hasVisualVulgarity = activeChunks.some(chunk => chunk.label === "VULGARITÉ VISUELLE");

    if (needsSkip) {
      const skipChunk = activeChunks.find(chunk => skipTypes.includes(chunk.label));
      videoRef.current.currentTime = skipChunk.end;
    } else if (hasSoundVulgarity) {
      videoRef.current.muted = true;
      setVideoStyle({ filter: "none" });
    } else if (hasVisualVulgarity) {
      videoRef.current.muted = false;
      setVideoStyle({ filter: "brightness(0)" });
    }

    if (lastToastRef.current !== activeChunks.map(chunk => chunk.label).join(',')) {
      lastToastRef.current = activeChunks.map(chunk => chunk.label).join(',');
      const lowercaseLabels = activeChunks.map(chunk => chunkLabelToLowercase(chunk.label));
      const message = lowercaseLabels.length > 2 
        ? `${lowercaseLabels.slice(0, -1).join(", ")} et ${lowercaseLabels[lowercaseLabels.length - 1]}`
        : lowercaseLabels.join(" et ");

      let toastMessage = "";
      if (needsSkip) {
        toastMessage = `La scène a été sautée car elle contient ${message}.`;
      } else if (hasSoundVulgarity) {
        toastMessage = `La scène a été mise en sourdine car elle contient ${message}.`;
      } else if (hasVisualVulgarity) {
        toastMessage = `La scène a été assombrie car elle contient ${message}.`;
      }
      toast.info(toastMessage);
    }
  };

  return (
    <div className="mt-12">
      <div className="mt-6">
        <video
          ref={videoRef}
          width="100%"
          controls
          onTimeUpdate={handleTimeUpdate}
          style={videoStyle}
        >
          <source src={video} type="video/mp4" />
          Votre navigateur ne prend pas en charge la balise vidéo.
        </video>
      </div>
      <ToastContainer position="bottom-right" autoClose={3000} />
    </div>
  );
}

export default PermissionsTest;